import {
	Component,
	NgZone
} from "@angular/core";
import {
	NavController,
	NavParams,
	ModalController,
	Events
} from "ionic-angular";

import {
	AddOrderServiceProvider
} from "./../add-order.service";

import {
	APIServiceProvider
} from "./../../../common/services/api.service";
import {
	HelperServiceProvider
} from "./../../../common/services/helper.service";

import {
	CropModalPage
} from "../../../modals/crop/crop.modal";

@Component({
	selector: "page-addcrop",
	templateUrl: "addcrop.html"
})
export class AddCropPage {
	constructor(
		public navCtrl: NavController,
		public helperService: HelperServiceProvider,
		public navParams: NavParams,
		public events: Events,
		public zone: NgZone,
		public modalController: ModalController,
		public addOrderService: AddOrderServiceProvider,
		public apiService: APIServiceProvider
	) {
		this.getFarmUnits();
	}

	saveCustomerBtn = false;

	all_crops: any = [];
	all_added_crops: any = [];

	former_types: any = [];

	query_types: any = [];
	states: any = [];

	units: any = [];

	ionViewWillLeave() {
		let backDrop: any = document.getElementsByTagName("datetime_input");
		if (backDrop.length > 0) {
			for (let i = 0; i < backDrop.length; i++) {
				backDrop[i].style.display = "none";
			}
		}
	}

	getFarmUnits() {
		this.apiService.get("farm/get-farm-units").subscribe(result => {
			this.units = result["data"];
		});
	}

	ionViewDidLoad() {
		this.events.subscribe("selected-crop", crop => {
			var crop_object: any = {};
			crop_object.id = crop.category_id;
			crop_object.crop_name = crop.category_name;

			this.addOrderService.postData.farms[crop.requestIndex].crop_name =
				crop_object.crop_name;
			this.addOrderService.postData.farms[crop.requestIndex].crop_id =
				crop_object.id;
		});
	}

	showSelectCrop(index) {
		let modalObject: any = {};

		modalObject = this.modalController.create(CropModalPage, {
			index: index
		});

		modalObject.present();
	}

	removeCrop(index) {
		this.addOrderService.postData.farms.splice(index, 1);
	}

	trackByData(index, item) {
		return item.crop_id;
	}

	addFarm() {
		let crop = {
			field_name: "",
			farm_id: null,
			crop_id: "",
			crop_name: "",
			area: "",
			unit: this.units[0]["id"],
			crop_sowing_date: new Date().toISOString().split("T")[0],
			showing_days: null
		};

		if (typeof this.addOrderService.postData.farms === "undefined") {
			this.addOrderService.postData.farms = [];
		}

		this.addOrderService.postData.farms.push(crop);
	}

	calcDaysAfterSowing(days, index) {
		const sowingDate = new Date();
		sowingDate.setDate(sowingDate.getDate() - days);
		this.addOrderService.postData.farms[index][
			"crop_sowing_date"
		] = sowingDate.toISOString().split("T")[0];
	}

	hasDuplicates(array: any) {
		var valuesSoFar = Object.create(null);
		for (var i = 0; i < array.length; ++i) {
			var value = array[i];
			if (value in valuesSoFar) {
				return true;
			}
			valuesSoFar[value] = true;
		}
		return false;
	}

	continueCustomerCrop() {
		var farms: any = [];

		if (this.addOrderService.postData.farms) {
			if (this.addOrderService.postData.farms.length > 0) {
				for (
					var i = 0; i < this.addOrderService.postData.farms.length; i++
				) {
					farms.push({
						field_name: this.addOrderService.postData.farms[i]
							.field_name,
						crop_id: this.addOrderService.postData.farms[i].crop_id,
						area: this.addOrderService.postData.farms[i].area,
						unit: this.addOrderService.postData.farms[i].unit,
						crop_sowing_date: this.addOrderService.postData.farms[i]
							.crop_sowing_date
					});
				}
			}
		}

		this.saveCustomerBtn = true;

		this.apiService
			.post("farm/add-farm", {
				customer_id: this.addOrderService.postData.customer_id,
				farms: farms
			})
			.subscribe(
				data => {
					this.navCtrl.parent.select(3);
					this.saveCustomerBtn = false;
				},
				error => {
					this.saveCustomerBtn = false;
					var message = error["error"]["msg"];
					for (var i = 0; i <= 5; i++) {
						message = message.replace("<br>", " ");
					}
					this.helperService.presentToast(message);
				}
			);
	}

	validateArea(farm) {

		let hasError = false;
		let self = this;

		var unit = farm.unit;
		var max_length = typeof farm.unit === 'string' ? null : farm.unit.max_length;

		if (!max_length) {
			self.units.forEach(function(inunit) {
				if (inunit.id == unit) {
					max_length = inunit.max_length;
				}
			});
		}

		if (farm.area && !isNaN(parseInt(farm.area))) {
			if (farm.area.toString().length > max_length) {
				hasError = true;
			}
		} else {
			hasError = true;
		}

		if (hasError) {
			this.helperService.presentToast("Enter valid value in area");
		}

		return hasError;
	}

	updateFarm(farm) {

		let checkArea = this.validateArea(farm);
		if (checkArea) {
			return false;
		}

		const param = {
			farm_id: farm["farm_id"],
			customer_id: this.addOrderService.postData.customer_id,
			field_name: farm["field_name"],
			crop_sowing_date: farm["crop_sowing_date"],
			unit: farm["unit"] !== null ? farm["unit"] : null,
			crop_id: farm["crop_id"] !== null ? farm["crop_id"] : null,
			area: farm["area"]
		};

		this.apiService.post("farm/update-farm", param).subscribe(
			result => {
				this.helperService.presentToast("Farm updated.");
			},
			err => {
				this.helperService.presentToast(err["error"]["msg"]);
			}
		);
	}

	save_farm(farm) {

		let checkArea = this.validateArea(farm);
		if (checkArea) {
			return false;
		}

		const param = {
			farm_id: farm["farm_id"],
			customer_id: this.addOrderService.postData.customer_id,
			field_name: farm["field_name"],
			crop_sowing_date: farm["crop_sowing_date"],
			unit: farm["unit"] !== null ? farm["unit"] : null,
			crop_id: farm["crop_id"] !== null ? farm["crop_id"] : null,
			area: farm["area"]
		};

		this.apiService.post("farm/save-farm", param).subscribe(
			result => {
				farm["farm_id"] = result["data"];

				this.helperService.presentToast("Farm saved.");
			},
			err => {
				this.helperService.presentToast(err["error"]["msg"]);
			}
		);
	}

	deleteFarm(farm) {
		farm["customer_id"] = this.addOrderService.postData.customer_id;
		this.apiService.post("farm/delete-farm", farm).subscribe(
			result => {
				this.addOrderService.postData.farms = this.addOrderService.postData.farms.filter(
					e => e.farm_id !== farm["farm_id"]
				);
				this.helperService.presentToast("Farm deleted.");
			},
			err => {
				this.helperService.presentToast(err["error"]["msg"]);
			}
		);
	}
}


// WEBPACK FOOTER //
// ./src/pages/addorder/addcrop/addcrop.ts